/** 고객센터 /support/faq용 — 랜딩 FAQ보다 넓게 */
export const publicFaqExtendedItems = [
  {
    question: '개인 설계사도 써볼 수 있나요?',
    answer: '네. 가입·계정 절차를 거치면 개인으로도 이용하실 수 있어요. 조직으로 도입하시면 권한·홈 기능을 함께 쓰실 수 있습니다.',
  },
  {
    question: '앱이에요, 웹이에요?',
    answer: '둘 다 있어요. 의뢰·조직 운용은 웹에서, 명함·알림·현장 확인은 앱에서 이어가기 좋게 구성되어 있어요.',
  },
  {
    question: '도입·이용 문의는 어디로 하면 되나요?',
    answer: '공개 문의 전용 페이지(/inquiry)에서 폼을 제출해 주세요. 접수 내용은 운영 쪽 고객문의로 전달됩니다.',
  },
  {
    question: '로그인 후 고객문의는 어떻게 하나요?',
    answer: '로그인한 계정은 웹 메뉴의 고객문의(비공개 문의/답변)를 이용할 수 있어요. 공개 랜딩 문의와는 별도 채널입니다.',
  },
  {
    question: '3NN·건축물대장 기능은 누가 쓰나요?',
    answer: '현장에서 상담·분석하시는 분들이 주로 활용하시고, 정리된 내용은 설계 의뢰로 이어질 수 있어요. 세부 범위는 계약·역할에 따라 달라질 수 있어요.',
  },
  {
    question: '요금은 어떻게 알 수 있나요?',
    answer: '이용 형태(개인/조직)·규모에 따라 달라질 수 있어요. 요금 안내 페이지를 참고하시고, 확정이 필요하면 문의로 남겨 주세요.',
  },
  {
    question: '결제·구매는 어디서 하나요?',
    answer: '정책에 따라 로그인 후 이용 또는 도입 계약 후 개시되는 경우가 많아요. 구매·결제 페이지에서 안내를 확인해 주세요.',
  },
  {
    question: '앱은 스토어에서 바로 받나요?',
    answer: '계정·운영 방식에 따라 안내가 달라질 수 있어요. 가입 또는 도입 문의 후 순서를 안내받으시는 걸 추천드려요.',
  },
]
